export const unreadMessagesSelector = state => state.privateConversations.unreadMessages;
export const allThreadsReadSelector = state => state.privateConversations.allThreadsRead;
